/**
 * Application entry point. Bootstraps Firebase, creates the production
 * AuthService, and mounts the React app.
 *
 * All sensitive config (API keys, SA key) lives in the Cloudflare Worker;
 * the Firebase WEB api key is public and intentionally in the client.
 */

import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initFirebase, readFirebaseEnv } from "./firebase/config.js";
import { createFirebaseAuthService } from "./auth/firebaseAuthService.js";
import { App } from "./App.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";

const env = readFirebaseEnv();
const firebase = initFirebase(env);
const service = createFirebaseAuthService(firebase.auth);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in index.html.");

createRoot(rootEl).render(
  <StrictMode>
    {/* Root ErrorBoundary: the app never blanks even on a catastrophic render error. */}
    <ErrorBoundary
      fallback={
        <div
          role="alert"
          aria-live="assertive"
          style={{ textAlign: "center", padding: "4rem 1rem", color: "#d1d5db" }}
        >
          <p style={{ fontWeight: 600, marginBottom: "0.5rem" }}>
            Algo salió mal — recargá la página.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: "1rem",
              minHeight: "44px",
              padding: "0 1.5rem",
              borderRadius: "0.5rem",
              border: "1px solid #3f3f46",
              background: "transparent",
              color: "#d1d5db",
              cursor: "pointer",
              fontSize: "0.875rem",
            }}
          >
            Recargar
          </button>
        </div>
      }
    >
      <App service={service} workerUrl={env.workerUrl} />
    </ErrorBoundary>
  </StrictMode>,
);
